var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useEffect, useMemo } from "react";
import { Button } from "../Button";
import AlertTitle from "./AlertTitle";
import AlertDescription from "./AlertDescription";
var Alert = forwardRef(function (_a, ref) {
    var children = _a.children, severity = _a.severity, size = _a.size, onClose = _a.onClose, _b = _a.focusCloseButton, focusCloseButton = _b === void 0 ? false : _b, className = _a.className, style = _a.style, otherProps = __rest(_a, ["children", "severity", "size", "onClose", "focusCloseButton", "className", "style"]);
    var alertClassName = useMemo(function () {
        var baseClassName = "fr-alert fr-alert--".concat(severity === "information" ? "info" : severity);
        var sizeClassName = size === "sm" ? " fr-alert--sm" : "";
        return className ? "".concat(baseClassName).concat(sizeClassName, " ").concat(className) : "".concat(baseClassName).concat(sizeClassName);
    }, [severity, size, className]);
    useEffect(function () {
        var hasTitle = React.Children.toArray(children).some(function (child) { return child.type === AlertTitle; });
        var hasDescription = React.Children.toArray(children).some(function (child) { return child.type === AlertDescription; });
        if (size === "sm" && !hasDescription) {
            console.warn("SM alert should have a description. Please add an AlertDescription component for SM alerts.");
        }
        if (size === "md" && !hasTitle) {
            console.warn("MD alert should have a title. Please add an AlertTitle component for MD alerts.");
        }
    }, [size, children]);
    return (React.createElement("div", __assign({}, otherProps, { ref: ref, className: alertClassName, style: style }),
        children,
        onClose && (React.createElement(Button, { className: "fr-btn--close", title: "Masquer le message", autoFocus: focusCloseButton, onClick: onClose }, "Masquer le message"))));
});
export default Alert;
